import PropTypes from 'prop-types';
import React from 'react';
import Button from 'yoda-core-components/lib/components/Button';
import Image from 'yoda-core-components/lib/components/Image/Image';
import { AMR_CO_PAYMENT_ADD_GC } from 'yoda-checkout-components/lib/common/AmrConstants';
import { imagePath } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { GC_TITLE } from 'yoda-checkout-components/lib/common/LabelConstants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

function AddGiftCardPaymentCTA(props) {
    const { buttonCTALabel, buttonCTAAction, context, renderCTA = false } = props;

    return (
        <div
            className={dt(['flex', 'justify-between', 'items-center'])}
            id={AMR_CO_PAYMENT_ADD_GC}
            data-automation-id="at-paymentMethod-gc-wrapper"
        >
            <div className={dt(['flex', 'items-center'])}>
                <div
                    className={dt(['w-8', 'h-8', 'mr-1'])}
                    data-automation-id="at-paymentMethod-cta-icon-giftCardCTA-gc"
                >
                    <Image
                        src={imagePath(context, 'icon-giftcard.svg')}
                        alt="icon"
                        imageRatio={0}
                    />
                </div>
                <span
                    data-automation-id="at-payment-gc-title"
                    className={dt([
                        'font-open-sans-semibold',
                        'sm:text-normal',
                        'text-black',
                        'ml-1',
                    ])}
                >
                    {GC_TITLE}
                </span>
            </div>
            {renderCTA && (
                <span className="clickable" data-automation-id="at-paymentMethod-cta-add-gc-block">
                    <Button
                        automationId="at-paymentMethod-cta-add-giftCardCTA-gc"
                        buttonType="Link"
                        size="Sm"
                        onClick={buttonCTAAction}
                    >
                        {buttonCTALabel}
                    </Button>
                </span>
            )}
        </div>
    );
}

AddGiftCardPaymentCTA.propTypes = {
    buttonCTALabel: PropTypes.string.isRequired,
    buttonCTAAction: PropTypes.objectOf(PropTypes.func).isRequired,
    context: PropTypes.objectOf(PropTypes.object).isRequired,
    renderCTA: PropTypes.bool,
};
AddGiftCardPaymentCTA.defaultProps = {
    renderCTA: false,
};

export default AddGiftCardPaymentCTA;
